module.exports = __webpack_public_path__ + "static/media/Zoom-out.a3a5391b.png";